import { getActiveChainConfig } from './chains'

// Get URLs from centralized chain config
const activeChain = getActiveChainConfig()

// Token list URL from chain config
export const DEFAULT_TOKEN_LIST_URL = activeChain.tokenListUrl ?? ''

export const DEFAULT_LIST_OF_LISTS: string[] = DEFAULT_TOKEN_LIST_URL ? [DEFAULT_TOKEN_LIST_URL] : []

// Pair list URL from chain config
export const DEFAULT_PAIR_LIST_URL = activeChain.lpListUrl ?? ''
